var map = {
	"./DSC08663.jpg": 9754,
	"./foodImg.jpg": 4230,
	"./img.jpg": 7986,
	"./img1.jpg": 4605,
	"./img10.jpg": 7729,
	"./img11.jpg": 9204,
	"./img12.jpg": 1011,
	"./img13.jpg": 9958,
	"./img2.jpg": 4706,
	"./img3.jpg": 2639,
	"./img4.jpg": 4676,
	"./img5.jpg": 2721,
	"./img6.jpg": 3142,
	"./img7.jpg": 6307,
	"./img8.jpg": 1816,
	"./img9.jpg": 4181,
	"./imgbg.jpg": 3555,
	"./imgbg2.jpg": 2857,
	"./imgbg3.jpg": 9132,
	"./imgbg4.jpg": 2919,
	"./imgbg5.jpg": 3914,
	"./imgbg6.jpg": 1253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2269;